import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  DeleteSavedFilter as DeleteSavedFilterGenerated,
  DeleteSavedFilterVariables as DeleteSavedFilterVariablesGenerated,
} from "core/queries/__generated__/DeleteSavedFilter";

// Queries
export interface DeleteSavedFilterResponse extends DeleteSavedFilterGenerated {}
export interface DeleteSavedFilterVariables
  extends DeleteSavedFilterVariablesGenerated {}

export const deleteSavedFilter = gql`
  mutation DeleteSavedFilter($id: ID!) {
    deleteSavedTomFilter(id: $id) {
      id
      success
    }
  }
`;

export interface UseGetSavedFiltersOptions {
  awaitRefetchQueries?: boolean;
  refetchQueries?: string[];
}

export const useDeleteSavedFilter = ({
  awaitRefetchQueries,
  refetchQueries = [],
}: UseGetSavedFiltersOptions) =>
  useMutation<DeleteSavedFilterResponse, DeleteSavedFilterVariables>(
    deleteSavedFilter,
    {
      awaitRefetchQueries,
      refetchQueries,
    },
  );
